import classNames from 'classnames';
import React from 'react';
import DragHotspot from 'components/DragHotspot';
import { SSIPosition } from 'const';
import { isHorizontalSSIPosition, isVerticalSSIPosition } from 'utils/ssi/ssiPosition';
import styles from './styles.module.scss';

type Props = {
  position: SSIPosition;
};

const SSIDragHotspot: React.FC<Props> = ({ position }) => (
  <div
    className={classNames(styles.sectionDragHotspot, {
      [styles.right]: isVerticalSSIPosition(position),
      [styles.bottom]: isHorizontalSSIPosition(position),
    })}
  >
    <DragHotspot />
  </div>
);

export default SSIDragHotspot;
